import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var startQuizRes;
export const startQuizTodo = createAsyncThunk('startQuiz', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/start_quiz',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": val.course_id,
                "quiz_id": val.quiz_id,
                "max_attemps_count": val.max_attempt_count,
                "passing_marks": val.passing_marks,
                "total_marks": val.total_marks,
                "fk_training_id": val.training_id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return startQuizRes = res.data
    } catch (error) {
        return startQuizRes = error.response.data
    }
})


const startQuizSlice = createSlice({
    name: 'startQuiz',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(startQuizTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('startQuiz', state.data)
            }
        });
        builder.addCase(startQuizTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default startQuizSlice.reducer; 